module.exports = __webpack_public_path__ + "assets/img/haveObtained_see.e02f5906.png";